__webpack_require__.p = "/QuizStacker/";